/* VN-AD — forward inbound tracking params to on-site links.
   Meta sets utm_* at the ad level, so the ad URL arrives with them but any
   hardcoded href on this lander would drop them at the hand-off to the PDP
   (the documented try.vetanica.co attribution gap). This carries whatever
   arrived — utm_*, fbclid, gclid, tw_* — through to the product page.
   Never overwrites a param already present on the link. */
(function () {
  function bare(h) { return String(h).replace(/^www\./, ''); }

  function run() {
    var qs = window.location.search;
    if (!qs || qs.length < 2) return;

    var incoming = new URLSearchParams(qs);
    var here = bare(window.location.host);
    var links = document.querySelectorAll('a[href]');

    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-vn-ad-fwd')) continue;

      var u;
      try { u = new URL(a.href, window.location.origin); } catch (e) { continue; }
      if (bare(u.host) !== here) continue;
      if (!/^\/(products|collections|cart|checkout|pages)/.test(u.pathname)) continue;

      incoming.forEach(function (value, key) {
        if (!u.searchParams.has(key)) u.searchParams.set(key, value);
      });

      a.href = u.toString();
      a.setAttribute('data-vn-ad-fwd', '1');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
